import { Get, getUrl, Post, Put } from '@/services/customer-support/index'

export const List = async body => {
  return Post(getUrl('cnps.css.device-store.get-list'), body)
}
export const DeviceDetails = async body => {
  return Post(getUrl('cnps.css.device-store.get-detail'), body)
}
